<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Member Participants</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-select outlined dense v-model="form.no_of_lions_members" :items="lionsMembersOptions"
              label="Lions Club Members"
              :error-messages="serverErrors.no_of_lions_members || ''"
              @input="clearServerError('no_of_lions_members')"></v-select>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-select outlined dense v-model="form.no_of_leo_members" :items="leoMembersOptions"
              label="LEO Club Members"
              :error-messages="serverErrors.no_of_leo_members || ''"
              @input="clearServerError('no_of_leo_members')"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-select outlined dense v-model="form.no_of_gst_members" :items="gstMembersOptions"
              label="GST/ Regional/ District Team Member"
              :error-messages="serverErrors.no_of_gst_members || ''"
              @input="clearServerError('no_of_gst_members')"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-checkbox v-model="form.has_community_leader" label="Community Leader (Mayor/ Grama Niladhari/ Principal/ Priest/ MOH/ PHI/ Police (DIG/ SSP/ OIC etc.)"
              :error-messages="serverErrors.has_community_leader || ''"
              @input="clearServerError('has_community_leader')"></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="previous()">Previous</v-btn>
          </v-col>
          <v-col cols="12" md="6" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",
  props: ["uuid"],
  components: { Alert, Snackbars },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    serverErrors: {},
    snackbar: false,
    succesMsg: "",
    form: {
      no_of_lions_members: 1,
      no_of_leo_members: 0,
      no_of_gst_members: 0,
      has_community_leader: false,
    },
    lionsMembersOptions: Array.from({ length: 20 }, (_, i) => i + 1),
    leoMembersOptions: Array.from({ length: 20 }, (_, i) => i + 1),
    gstMembersOptions: Array.from({ length: 10 }, (_, i) => i + 1),
  }),

  mounted() {
    this.getProjectInfo();
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  methods: {
    submit() {
      this.loading = true;
      this.serverErrors = {};
      ProjectService.update(this.uuid, this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.succesMsg = "Success";
            this.snackbar = true;
            this.$router.push({ name: 'ProjectEdit', params: { step: 5, uuid: this.uuid } });
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          this.serverErrors = checkError.fieldErrorFormatting(data);
        });
    },

    getProjectInfo() {
      if (this.uuid !== null) {
        this.loading = true;
        ProjectService.getProjectInfo(this.uuid)
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.form.no_of_lions_members = response.data.data.no_of_lions_members || 1;
              this.form.no_of_leo_members = response.data.data.no_of_leo_members || 0;
              this.form.no_of_gst_members = response.data.data.no_of_gst_members || 0;
              this.form.has_community_leader = response.data.data.has_community_leader || false;
            }
          })
          .catch((error) => {
            this.loading = false;
            if (error.response) {
              let data = error.response.data;
              let errorOutput = checkError.errorFormatting(data);
              this.errors = errorOutput;
            }
          });
      }
    },

    previous() {
      this.$router.push({ name: 'ProjectEdit', params: { step: 3, uuid: this.uuid } })
    },

    onDismissed() {
      this.errors = null;
      this.serverErrors = {};
    },
    clearServerError(field) {
      this.$delete(this.serverErrors, field);
    },
    clossSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
